<nav aria-label="Breadcrumb" class="crumbs">
  <ol class="crumbs__list">
    @for (breadcrumb of breadcrumbs$ | async; track $index) {
      <li class="crumbs__item">
        @if (!$last) {
          <a [routerLink]="breadcrumb.url" class="crumbs__link">{{ breadcrumb.label }}</a>
          <span class="bk-sym crumbs__sep" aria-hidden="true">chevron_right</span>
        } @else {
          <span class="crumbs__current" aria-current="page">{{ breadcrumb.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
